export default __webpack_public_path__ + "static/media/dentes-azul.83f505b0.png";